import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Pre-rendered routes ship real HTML inside #root (see scripts/prerender-apply.js).
// Hydrate in place so the static content stays visible while route chunks load;
// if the SPA fallback served another route's snapshot, wipe it and render fresh.
const prerenderedFor = container.dataset.prerenderPath;
if (container.hasChildNodes() && prerenderedFor === window.location.pathname) {
  ReactDOM.hydrateRoot(container, tree, { onRecoverableError: () => {} });
} else {
  container.innerHTML = "";
  ReactDOM.createRoot(container).render(tree);
}
